module.exports = __webpack_public_path__ + "media/images/bgc-badge-898df8a800600b5586d3e2c12f1dbf53.svg";